/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom"; // Added Link import
import { useTranslation } from "react-i18next"; // Added useTranslation import
import Select from "react-select";

import { getData, postData, putData, uploadMultipleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { reactSelectStyle } from "Config/Config"; // Added reactSelectStyle import
import FileUploadField from "components/Common/FileUploadField/FileUploadField"; // Added FileUploadField import
import contractOptions from "data/Prod/ContractType.json";
import currencyOptions from "data/Prod/Currency.json";
import frequencyOptions from "data/Prod/FrequencyOptions.json";

const SaveContractPopup = ({
  selectedContractId = null,
  setSelectedContractId = () => {},
  afterPopupClose = () => {},
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const { t } = useTranslation(); // Added translation hook
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const todayValue = new Date().toISOString().split("T")[0];

  const [companyTypeList, setCompanyTypeList] = useState([]);
  const [companyInput, setCompanyInput] = useState("");
  const [companyList, setCompanyList] = useState([]);

  // Basic states
  const [companyType, setCompanyType] = useState(null);
  const [companyTypeValue, setCompanyTypeValue] = useState(null);
  const [contractType, setContractType] = useState("");
  const [contractTypeValue, setContractTypeValue] = useState(null);
  const [startDate, setStartDate] = useState(todayValue);
  const [endDate, setEndDate] = useState(todayValue);
  const [isActive, setIsActive] = useState(false);

  // Provider states
  const [providerCompany, setProviderCompany] = useState(null);
  const [providerCompanyValue, setProviderCompanyValue] = useState(null);
  const [provider, setProvider] = useState({
    name: "",
    contactperson: "",
    contactpersonemail: "",
    phone: "",
    email: "",
    cif: "",
    address: "",
  });

  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState("");
  const [currencyValue, setCurrencyValue] = useState(null);
  const [frequency, setFrequency] = useState("");
  const [frequencyValue, setFrequencyValue] = useState(null);

  // Renewal states
  const [renewal, setRenewal] = useState({
    days: "",
    notificationsent: false,
    notificationdate: todayValue,
  });

  const [autorenewal, setAutorenewal] = useState(false);
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [uploadedDocFileIds, setUploadedDocFileIds] = useState([]);

  const [isSaving, setIsSaving] = useState(false); // Added isSaving state
  const [errors, setErrors] = useState({});
  const offcanvasBodyRef = useRef(null);

  const validateForm = () => {
    const newErrors = {};

    if (!companyType) {
      newErrors.companyType = t("Please select a company type.");
    }
    if (!contractType) {
      newErrors.contractType = t("Please select a contract type.");
    }
    if (new Date(startDate) > new Date(endDate)) {
      newErrors.dateComparison = t("End Date cannot be before Start Date.");
    }
    if (!provider.name.trim()) {
      newErrors.providerName = t("Provider Name is required.");
    }

    if (!provider.contactperson.trim()) {
      newErrors.providerContactPerson = t(
        "Provider Contact Person Name is required."
      );
    }

    if (!provider.contactpersonemail.trim()) {
      newErrors.providerContactPersonEmail = t(
        "Provider Contact Person Email is required."
      );
    }

    if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        provider.contactpersonemail
      )
    ) {
      newErrors.providerContactPersonEmail = t(
        "Provider Contact Person Email is not valid."
      );
    }

    if (!provider.phone.trim()) {
      newErrors.providerPhone = t("Provider Phone is required.");
    }
    if (!provider.address.trim()) {
      newErrors.providerAddress = t("Provider Address is required.");
    }

    if (!provider.cif.trim()) {
      newErrors.providerCif = t("Tax Identification (CIF) is required.");
    }

    if (provider.email.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(provider.email)) {
        newErrors.providerEmail = t("Please enter a valid email address.");
      }
    } else {
      newErrors.providerEmail = t("Email is required.");
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      if (offcanvasBodyRef.current) {
        offcanvasBodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
    return Object.keys(newErrors).length === 0;
  };

  //function for get all company type
  const getAllCompanyType = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_COMPANY_TYPE + `?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status) setCompanyTypeList(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all contacts
  const getAllCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY +
        `?token=${token}&filtername=${companyInput}&modulefrom=backend`;

      const response = await getData(requestUrl);

      console.log("response in company------>", response);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for select company type
  const companyTypeSelectionHandler = (val) => {
    if (val) {
      setCompanyTypeValue(val);
      setCompanyType(val.value);
    } else {
      setCompanyTypeValue(null);
      setCompanyType(null);
    }
  };

  //function for select contract type
  const contractTypeSelectionHandler = (val) => {
    if (val) {
      setContractTypeValue(val);
      setContractType(val.value);
    } else {
      setContractTypeValue(null);
      setContractType("");
    }
  };

  //fucntion for company selection
  const companySelectionHandler = (val) => {
    if (val) {
      setProviderCompanyValue(val);
      setProviderCompany(val.value);
      setProvider({
        name: val.label,
        contactperson: val.ownerfullname,
        contactpersonemail: val.owneremail,
        phone: val.phone,
        email: val.email,
        cif: val.cif,
        address: val.location,
      });
    } else {
      setProviderCompanyValue(null);
      setProviderCompany(null);
      setProvider({
        name: "",
        contactperson: "",
        contactpersonemail: "",
        phone: "",
        email: "",
        cif: "",
        address: "",
      });
    }
  };

  //function for current selection
  const currencySelectionHandler = (val) => {
    if (val) {
      setCurrencyValue(val);
      setCurrency(val.value);
    } else {
      setCurrencyValue(null);
      setCurrency("");
    }
  };

  //function for frequency selection
  const frequencySelectionHandler = (val) => {
    if (val) {
      setFrequencyValue(val);
      setFrequency(val.value);
    } else {
      setFrequencyValue(null);
      setFrequency("");
    }
  };

  //function for upload doc files
  const docFileUploadHandler = async (docFiles) => {
    try {
      setDocFileUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, docFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedDocFiles.length == 0) {
          setUploadedDocFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedDocFiles.concat(uploadedFileValues);
          setUploadedDocFiles(fileArr);
        }

        /*----- assign uploaded files with path for display end ------*/
        setDocFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedDocFileIds.length == 0) {
          setUploadedDocFileIds(fileIds);
        } else {
          let fileArr = uploadedDocFileIds.concat(fileIds);
          setUploadedDocFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    const closedFile = [...uploadedDocFiles];
    const removedFileId = [...uploadedDocFileIds];
    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);
    setUploadedDocFiles(closedFile);
    setUploadedDocFileIds(removedFileId);
  };

  //function for get contract details
  const getContractDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_COMPANY_CONTRACT_DETAILS +
        `/${selectedContractId}?token=${token}`;

      console.log("url in contract details----->", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in contract details----->", response);

      if (response.status) {
        const data = response.data;

        companyTypeSelectionHandler(data.companytypevalue);

        const contractTypeData = contractOptions.find(
          (option) => option.value === data.contracttype
        );
        contractTypeSelectionHandler(contractTypeData);

        setStartDate(data.startdate);
        setEndDate(data.enddate);
        setIsActive(data.active);

        setProviderCompany(data.providerid._id);
        setProviderCompanyValue(data.providervalue);

        setProvider(data.provider);
        setAmount(data.amount);

        const currencyData = currencyOptions.find(
          (option) => option.value === data.currency
        );
        currencySelectionHandler(currencyData);

        const frequencyData = frequencyOptions.find(
          (option) => option.value === data.frequency
        );

        frequencySelectionHandler(frequencyData);

        setRenewal(data.renewal);
        setAutorenewal(data.autorenewal);

        setUploadedDocFiles(
          data.documents.map(({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          }))
        );

        setUploadedDocFileIds(data.documents.map(({ _id, ...other }) => _id));
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const saveContractHandler = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true); // Set saving state to true
      const formData = {
        companyid: params.id,
        companytype: companyType,
        contracttype: contractType,
        startdate: startDate,
        enddate: endDate,
        active: isActive,
        providerid: providerCompany,
        provider,
        amount: Number(amount) || 0,
        currency: currency,
        frequency: frequency,
        renewal,
        autorenewal,
        documents: uploadedDocFileIds,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (selectedContractId) {
        requestUrl +=
          url.API_UPDATE_COMPANY_CONTRACT +
          `/${selectedContractId}` +
          `?token=${token}`;
        response = await putData(requestUrl, formData);
      } else {
        requestUrl += url.API_ADD_COMPANY_CONTRACT + `?token=${token}`;
        response = await postData(requestUrl, formData);
      }

      setIsSaving(false); // Set saving state to false

      console.log("response in save contract----->", response);

      if (response.status) {
        // close the popup
        let offCanvasPopup = document.querySelector("#saveContract");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        afterPopupClose(response.data);
        resetHandler();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Reset handler for form fields
  const resetHandler = () => {
    setCompanyInput("");
    setCompanyList([]);
    setCompanyTypeValue(null);
    setContractTypeValue(null);
    setCompanyType(null);
    setContractType(null);
    setStartDate(todayValue);
    setEndDate(todayValue);
    setIsActive(false);
    setProviderCompany(null);
    setProviderCompanyValue(null);
    setProvider({
      name: "",
      contactperson: "",
      contactpersonemail: "",
      phone: "",
      email: "",
      cif: "",
      address: "",
    });
    setAmount(0);
    setCurrency("");
    setCurrencyValue(null);
    setFrequency("");
    setFrequencyValue(null);
    setRenewal({
      days: "",
      notificationsent: false,
      notificationdate: todayValue,
    });
    setAutorenewal(false);
    setUploadedDocFiles([]);
    setUploadedDocFileIds([]);
    setSelectedContractId(null);
    setErrors({});
  };

  const customStyles = (hasError) => ({
    control: (base, state) => ({
      ...base,
      borderColor: hasError ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: hasError ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  });

  useEffect(() => {
    if (companyInput.length > 1) {
      getAllCompanyList();
    }
  }, [companyInput]);

  useEffect(() => {
    if (selectedContractId) {
      getContractDetails();
    }
  }, [selectedContractId]);

  useEffect(() => {
    getAllCompanyType();
  }, []);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveContract"
      aria-labelledby="saveContract"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              description
            </span>{" "}
            {/* Using 'description' icon as a placeholder */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              Create / Edit Contract
            </h3>
            <p className="text-white fs-sm mb-0">
              Manage existing contract details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      <div className="offcanvas-body p-4" ref={offcanvasBodyRef}>
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* Company Type and Contract Type */}
              <div className="d-flex gap-3 mb-4">
                <div className="form-group p-3 border rounded-8 shadow-sm bg-white w-50">
                  <label
                    htmlFor="companyType"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Company Type
                  </label>
                  <Select
                    isClearable
                    options={companyTypeList}
                    value={companyTypeValue}
                    onChange={(val) => {
                      companyTypeSelectionHandler(val);
                      if (errors.companyType) {
                        setErrors((prev) => ({ ...prev, companyType: "" }));
                      }
                    }}
                    styles={customStyles(errors.companyType)}
                    placeholder="Choose your company type..."
                    id="companyType"
                  />
                  {errors.companyType && (
                    <div className="invalid-feedback d-block">
                      {errors.companyType}
                    </div>
                  )}
                </div>

                <div className="form-group p-3 border rounded-8 shadow-sm bg-white w-50">
                  <label
                    htmlFor="contractType"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Contract Type
                  </label>
                  <Select
                    isClearable
                    options={contractOptions}
                    value={contractTypeValue}
                    onChange={(val) => {
                      contractTypeSelectionHandler(val);
                      if (errors.contractType) {
                        setErrors((prev) => ({ ...prev, contractType: "" }));
                      }
                    }}
                    styles={customStyles(errors.contractType)}
                    placeholder="Select contract category..."
                    id="contractType"
                  />
                  {errors.contractType && (
                    <div className="invalid-feedback d-block">
                      {errors.contractType}
                    </div>
                  )}
                </div>
              </div>

              {/* Start Date and End Date */}
              <div className="d-flex gap-3 mb-4">
                <div className="form-group p-3 border rounded-8 shadow-sm bg-white w-50">
                  <label
                    htmlFor="startDate"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Start Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    className={`form-control fs-sm shadow-none ${
                      errors.dateComparison
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      if (errors.dateComparison) {
                        setErrors((prev) => ({ ...prev, dateComparison: "" }));
                      }
                    }}
                  />
                </div>

                <div className="form-group p-3 border rounded-8 shadow-sm bg-white w-50">
                  <label
                    htmlFor="endDate"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    End Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    className={`form-control fs-sm shadow-none ${
                      errors.dateComparison
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                      if (errors.dateComparison) {
                        setErrors((prev) => ({ ...prev, dateComparison: "" }));
                      }
                    }}
                  />
                  {errors.dateComparison && (
                    <div className="invalid-feedback d-block">
                      {errors.dateComparison}
                    </div>
                  )}
                </div>
              </div>

              {/* is active checkbox */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                  <input
                    type="checkbox"
                    id="isActive"
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                  />
                  <label
                    htmlFor="isActive"
                    className="form-check-label fw-semibold text-dark"
                  >
                    Is Active
                  </label>
                </div>
              </div>

              {/* Provider Company */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="providerCompany"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  Provider Company
                </label>
                <Select
                  options={companyList}
                  value={providerCompanyValue}
                  onChange={companySelectionHandler}
                  onInputChange={(val) => setCompanyInput(val)}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  placeholder="Search and select provider company..."
                  isClearable
                />
              </div>

              {/* Provider Details */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="text-primary fw-semibold mb-3">
                  Provider Details
                </h5>
                <div className="d-flex gap-3 mb-2">
                  <div className="form-group w-50">
                    <label
                      htmlFor="providerName"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="providerName"
                      className={`form-control fs-sm shadow-none ${
                        errors.providerName
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      value={provider.name}
                      onChange={(e) => {
                        setProvider({ ...provider, name: e.target.value });
                        if (errors.providerName) {
                          setErrors((prev) => ({ ...prev, providerName: "" }));
                        }
                      }}
                      placeholder="Enter provider company name..."
                    />
                    {errors.providerName && (
                      <div className="invalid-feedback d-block">
                        {errors.providerName}
                      </div>
                    )}
                  </div>
                  <div className="form-group w-50">
                    <label
                      htmlFor="providerEmail"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="providerEmail"
                      className={`form-control fs-sm shadow-none ${
                        errors.providerEmail
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      value={provider.email}
                      onChange={(e) => {
                        setProvider({ ...provider, email: e.target.value });
                        if (errors.providerEmail) {
                          setErrors((prev) => ({ ...prev, providerEmail: "" }));
                        }
                      }}
                      placeholder="contact@providercompany.com"
                    />
                    {errors.providerEmail && (
                      <div className="invalid-feedback d-block">
                        {errors.providerEmail}
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex gap-3 mb-2">
                  <div className="form-group w-50">
                    <label
                      htmlFor="taxId"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Tax Identification (CIF){" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="taxId"
                      className={`form-control fs-sm shadow-none ${
                        errors.providerCif
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      value={provider.cif}
                      onChange={(e) => {
                        setProvider({ ...provider, cif: e.target.value });
                        if (errors.providerCif) {
                          setErrors((prev) => ({ ...prev, providerCif: "" }));
                        }
                      }}
                      placeholder="Enter tax identification (CIF) number..."
                    />
                    {errors.providerCif && (
                      <div className="invalid-feedback d-block">
                        {errors.providerCif}
                      </div>
                    )}
                  </div>
                  <div className="form-group w-50">
                    <label
                      htmlFor="providerPhone"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Phone <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="providerPhone"
                      className={`form-control fs-sm shadow-none ${
                        errors.providerPhone
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      value={provider.phone}
                      onChange={(e) => {
                        setProvider({ ...provider, phone: e.target.value });
                        if (errors.providerPhone) {
                          setErrors((prev) => ({ ...prev, providerPhone: "" }));
                        }
                      }}
                      placeholder="+1 (555) 123-4567"
                    />
                    {errors.providerPhone && (
                      <div className="invalid-feedback d-block">
                        {errors.providerPhone}
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex gap-3 mb-2">
                  {" "}
                  <div className="form-group w-50">
                    <label
                      htmlFor="contactPerson"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Contact Person Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="contactPerson"
                      className={`form-control fs-sm shadow-none ${
                        errors.providerContactPerson
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      value={provider.contactperson}
                      onChange={(e) => {
                        setProvider({
                          ...provider,
                          contactperson: e.target.value,
                        });
                        if (errors.providerContactPerson) {
                          setErrors((prev) => ({
                            ...prev,
                            providerContactPerson: "",
                          }));
                        }
                      }}
                      placeholder="e.g. John Smith, Account Manager"
                    />
                    {errors.providerContactPerson && (
                      <div className="invalid-feedback d-block">
                        {errors.providerContactPerson}
                      </div>
                    )}
                  </div>
                  <div className="form-group w-50">
                    <label
                      htmlFor="contactPerson"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Contact Person Email{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="contactPerson"
                      className={`form-control fs-sm shadow-none ${
                        errors.providerContactPersonEmail
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      value={provider.contactpersonemail}
                      onChange={(e) => {
                        setProvider({
                          ...provider,
                          contactpersonemail: e.target.value,
                        });
                        if (errors.providerContactPersonEmail) {
                          setErrors((prev) => ({
                            ...prev,
                            providerContactPersonEmail: "",
                          }));
                        }
                      }}
                      placeholder="e.g. john.smith@example.com"
                    />
                    {errors.providerContactPersonEmail && (
                      <div className="invalid-feedback d-block">
                        {errors.providerContactPersonEmail}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group mb-2">
                  <label
                    htmlFor="providerAddress"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Location <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="providerAddress"
                    className={`form-control fs-sm shadow-none ${
                      errors.providerAddress
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    value={provider.address}
                    onChange={(e) => {
                      setProvider({ ...provider, address: e.target.value });
                      if (errors.providerAddress) {
                        setErrors((prev) => ({
                          ...prev,
                          providerAddress: "",
                        }));
                      }
                    }}
                    placeholder="Enter complete business address including street, city, state, and postal code..."
                    rows="3"
                  ></textarea>
                  {errors.providerAddress && (
                    <div className="invalid-feedback d-block">
                      {errors.providerAddress}
                    </div>
                  )}
                </div>
              </div>

              {/* Amount, Currency, Frequency */}
              <div className="d-flex gap-3 mb-4">
                <div
                  className="form-group p-3 border rounded-8 shadow-sm bg-white"
                  style={{ flex: 1, minWidth: 0 }}
                >
                  <label
                    htmlFor="amount"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Amount
                  </label>
                  <input
                    type="number"
                    id="amount"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="0"
                    min="0"
                    step="1"
                  />
                </div>

                <div
                  className="form-group p-3 border rounded-8 shadow-sm bg-white"
                  style={{ flex: 1, minWidth: 0 }}
                >
                  <label
                    htmlFor="currency"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Currency
                  </label>
                  <Select
                    isClearable
                    options={currencyOptions}
                    value={currencyValue}
                    onChange={currencySelectionHandler}
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder="USD, EUR, GBP..."
                    id="currency"
                  />
                </div>

                <div
                  className="form-group p-3 border rounded-8 shadow-sm bg-white"
                  style={{ flex: 1, minWidth: 0 }}
                >
                  <label
                    htmlFor="frequency"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Frequency
                  </label>
                  <Select
                    isClearable
                    options={frequencyOptions}
                    value={frequencyValue}
                    onChange={frequencySelectionHandler}
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder="Monthly, Yearly, One-time..."
                    id="frequency"
                  />
                </div>
              </div>

              {/* Renewal */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="text-primary fw-semibold mb-3">Renewal</h5>
                <div className="d-flex gap-3 mb-3">
                  <div className="form-group w-50">
                    <label
                      htmlFor="renewalDays"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Days before expiry
                    </label>
                    <input
                      type="number"
                      id="renewalDays"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      value={renewal.days}
                      onChange={(e) =>
                        setRenewal({ ...renewal, days: e.target.value })
                      }
                      placeholder="e.g. 30"
                      min="0"
                      max="365"
                    />
                  </div>
                  <div className="form-group w-50">
                    <label
                      htmlFor="notificationDate"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Notification Date
                    </label>
                    <input
                      type="date"
                      id="notificationDate"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      value={renewal.notificationdate}
                      onChange={(e) =>
                        setRenewal({
                          ...renewal,
                          notificationdate: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0 mb-2">
                  <input
                    type="checkbox"
                    id="notificationSent"
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    checked={renewal.notificationsent}
                    onChange={(e) =>
                      setRenewal({
                        ...renewal,
                        notificationsent: e.target.checked,
                      })
                    }
                  />
                  <label
                    htmlFor="notificationSent"
                    className="form-check-label fw-semibold text-dark"
                  >
                    Send Notification
                  </label>
                </div>
              </div>

              {/* Auto Renewal */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                  <input
                    type="checkbox"
                    id="autoRenewal"
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    checked={autorenewal}
                    onChange={(e) => setAutorenewal(e.target.checked)}
                  />
                  <label
                    htmlFor="autoRenewal"
                    className="form-check-label fw-semibold text-dark"
                  >
                    Auto Renewal
                  </label>
                </div>
              </div>

              {/* ------ upload documnet section start ------- */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="documents"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Documents")}
                </label>
                <FileUploadField
                  label={t("Upload Documents")}
                  accept="doc mp4 pdf"
                  onUpload={docFileUploadHandler}
                  files={uploadedDocFiles}
                  onRemove={closeDocFileHandler}
                  loading={docFileUploading}
                  multiple
                  fileType="document"
                />
              </div>
              {/* ------ upload documnet section end ------- */}
            </div>

            {/* Actions */}
            <div className="action d-flex justify-content-between gap-3 pt-3 border-top mt-auto">
              <Link
                to="#"
                className="btn btn-outline-primary d-flex align-items-center gap-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={resetHandler}
              >
                <span className="material-symbols-outlined me-1">cancel</span>{" "}
                Close
              </Link>
              <button
                onClick={saveContractHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    Save Contract
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveContractPopup;
